module.exports = __webpack_public_path__ + "img/26.1e8856bc.gif";